import * as React from 'react'
import { LabelsMain } from './LabelsMain'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const LabelsMainExamples = () => {
  return (
    <div className="LabelsMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <LabelsMain />
      </Provider>
    </div>
  )
}
